import { V3RequestParser } from "@curio/client/parsers";
import { Session } from "./Session";
import { SessionManager } from "./SessionManager";
import { createV3Validator } from "@curio/client/validators";
import { FetchLink } from "@curio/client/links";

export interface Config {
  service: {
    url: string;
    server: string;
    system: number;
    port: number;
  };
  accessToken: string;
  resources: {
    get: string;
    put: string;
    viewer: string;
  };
  logs: boolean;
}

const createSessionManager = (configuration: Config) => {
  const link = new FetchLink(configuration.service);
  const requestParser = new V3RequestParser(configuration.service);

  return new SessionManager(configuration.service, (request) => {
    return Promise.resolve(request)
      .then(requestParser.parse)
      .then(JSON.stringify)
      .then(link.parse)
      .then(link.post)
      .then((response) => response.json())
      .then(createV3Validator(request).validate);
  });
};

export const getSessionManager = async () => {
  const CONFIG_PATH = "./config.json";

  const cnfg = await (await fetch(CONFIG_PATH)).json();
  const sessionManager = createSessionManager(cnfg);
  return sessionManager;
};

export type { Service as SV } from "./SessionManager";
export { Session, SessionManager };
export { isAuthError } from "./isAuthError";
export * from "./SessionManager";
